import { createFeatureSelector, createSelector } from '@ngrx/store';

// Prettier 1.18.2 cannot parse `import type`, and the pre-commit hook runs it,
// so the type rides along on a plain import. TypeScript elides it.
import { QueueItem } from 'capacitor-clogi-uploader';

import { State } from './upload-queue.reducer';

export const selectUploadQueueState = createFeatureSelector<State>(
  'uploadQueue'
);

export const selectUploadQueue = createSelector(
  selectUploadQueueState,
  state => state.items
);

export const selectActiveUploadCount = createSelector(
  selectUploadQueue,
  items => items.filter(item => item.state !== 'failed').length
);

export const selectFailedUploads = createSelector(
  selectUploadQueue,
  items => items.filter(item => item.state === 'failed')
);

export const selectQueueItemByEntityId = (entityId: string) =>
  createSelector(
    selectUploadQueue,
    (items): QueueItem | undefined =>
      items.find(item => item.entityId === entityId)
  );

export const selectAggregateProgress = createSelector(
  selectUploadQueue,
  items => {
    const active = items.filter(item => item.state !== 'failed');
    if (active.length === 0) {
      return 0;
    }
    const total = active.reduce((sum, item) => sum + (item.bytesTotal || 0), 0);
    const sent = active.reduce((sum, item) => sum + (item.bytesSent || 0), 0);
    return total === 0 ? 0 : sent / total;
  }
);
